/*
 *  THIS COMPONENT IS DEPRECATED
 *  Please use 'useForm' hook instead
 */
import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { AnyObjectSchema } from 'yup'

import * as Styled from './styles'

export type FormSubmittedData = {
  id?: string
  [key: string]: any
}

export type FormsProps = {
  defaultValues?: {}
  children?: React.ReactNode
  onSubmit?: Function
  resetForm?: boolean
  validationSchema?: AnyObjectSchema
}

export const Form = ({ children, defaultValues, onSubmit, resetForm, validationSchema, ...rest }: FormsProps) => {
  const form = useForm({
    defaultValues,
    resolver: validationSchema ? yupResolver(validationSchema) : undefined,
  })

  const handleSubmit = (data: any) => {
    if (onSubmit) {
      onSubmit(data)
    }
  }

  if (resetForm) {
    return <form>{children}</form>
  }

  return (
    <FormProvider {...form}>
      <Styled.FormComponent onSubmit={form.handleSubmit(handleSubmit)}>{children}</Styled.FormComponent>
    </FormProvider>
  )
}
